import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6b986862&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UserState: require('/gitlab-runner-data/builds/ns-am/product/apps/catalog/components/UserState.vue').default,ProductDetail: require('/gitlab-runner-data/builds/ns-am/product/apps/catalog/components/ProductDetail.vue').default})
